import React from 'react';
import moment from 'moment';

import clockIcon from '../../../../../../assets/images/icon-clock.png';

import { Container, Row, Col } from './styles.js';
import './styles.css';

function TimeLine({
  checkIn,
  finishedAt,
  receivedByLuft,
  stay,
  transmissionDelay,
}) {
  return (
    <div className="DrawerContainer__borderContainer DrawerContainer__timeLineContainer">
      <Row>
        <Col className="StyledCol">
          <Container>
            <Row className="StyledRow">
              <Col>
                <div className="DrawerContainer__timeline-col">
                  <div>
                    <div className="DrawerContainer__bullet" />
                    <div className="DrawerContainer__line" />
                  </div>
                  <div className="DrawerContainer__timeline-info">
                    <p className="DrawerContainer__itemName">Check-in</p>
                    <p className="DrawerContainer__itemValue">
                      {moment(checkIn).format('DD/MM/YYYY • HH:mm:ss')}
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
            <Row className="StyledRow">
              <Col>
                <div className="DrawerContainer__timeline-col">
                  <div>
                    <div className="DrawerContainer__bullet" />
                    <div className="DrawerContainer__line" />
                  </div>
                  <div className="DrawerContainer__timeline-info">
                    <p className="DrawerContainer__itemName">Baixa</p>
                    <p className="DrawerContainer__itemValue">
                      {moment(finishedAt).format('DD/MM/YYYY • HH:mm:ss')}
                    </p>
                    <div className="DrawerContainer__timeline-timer">
                      <p className="DrawerContainer__timeline-timerTitle">
                        Tempo de permanência
                      </p>
                      <div className="DrawerContainer__timeline-timerValue">
                        <img alt="" src={clockIcon} />
                        <p>{stay}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </Col>
        <Col className="StyledCol">
          <Container>
            <Row className="StyledRow">
              <Col>
                <div className="DrawerContainer__timeline-col  nobullet-col">
                  <div>
                    <div className="DrawerContainer__line no-bullet" />
                  </div>
                  <div className="DrawerContainer__timeline-info">
                    <div />
                  </div>
                </div>
              </Col>
            </Row>
            <Row className="StyledRow">
              <Col>
                <div className="DrawerContainer__timeline-col">
                  <div>
                    <div className="DrawerContainer__bullet light" />
                  </div>
                  <div className="DrawerContainer__timeline-info">
                    <div />
                    <p className="DrawerContainer__itemName light">
                      Recebido pela Luft
                    </p>
                    <p className="DrawerContainer__itemValue">
                      {moment(receivedByLuft).format('DD/MM/YYYY • HH:mm:ss')}
                    </p>
                    <div className="DrawerContainer__timeline-timer light">
                      <p className="DrawerContainer__timeline-timerTitle">
                        Delay de transmissão
                      </p>
                      <div className="DrawerContainer__timeline-timerValue">
                        <img alt="" src={clockIcon} />
                        <p>{transmissionDelay}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </Col>
      </Row>
    </div>
  );
}

export default TimeLine;
